import React, { useState, useEffect, Fragment } from 'react';
import { Row, Card, Button, CardBody, CardTitle } from 'reactstrap';
import { Colxx } from '../../../../components/common/CustomBootstrap';
import { AxiosAPI } from '../../../../helpers/AxiosAPI';
import { gAPI_Bookings_list } from '../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import moment from 'moment';
import DetailButton from './components/DetailButton';
import DatePicker from 'react-datepicker';
import TuneIcon from '@mui/icons-material/Tune';
import IntlMessages from '../../../../helpers/IntlMessages';
import ReactTable from 'react-table';
import DataTablePagination from '../../../../components/DatatablePagination';

const BookingsList = ({ propertyId }) => {
  const [isFiltering, setIsFiltering] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [startDate, setStartDate] = useState(moment().subtract(15, 'days'));
  const [endDate, setEndDate] = useState(moment());
  const [bookingsList, setBookingsList] = useState([]);
  const dataTableColumns = [
    {
      Header: 'Booking Date (UTC)',
      accessor: 'bookingDateTime',
      Cell: props => <p className="">{moment(props.value).format('LLL')}</p>,
      style: { 'whiteSpace': 'unset' }
    },
    {
      Header: 'Reference Number',
      accessor: 'bookingNumber',
      Cell: props => <p className="">{props.value}</p>,
      style: { 'whiteSpace': 'unset' }
    },
    {
      Header: 'Check In Date',
      accessor: 'checkInDate',
      Cell: props => <p className="">  {moment(props.value).format('LL')}</p>,
      width: 100,
      style: { 'whiteSpace': 'unset' }
    },
    {
      Header: 'Check Out',
      accessor: 'checkOutDate',
      Cell: props => <p className="">{moment(props.value).format('LL')}</p>,
      width: 100,
      style: { 'whiteSpace': 'unset' }
    },
    {
      Header: 'Adults',
      accessor: 'adults',
      Cell: props => <p className="">{props.value}</p>,
      width: 50
    },
    {
      Header: 'Childrens',
      accessor: 'childrens',
      Cell: props => <p className="">{props.value}</p>,
      width: 50
    },
    {
      Header: 'Rooms',
      accessor: 'roomsUnits',
      Cell: props => <p className="">{props.value}</p>,
      width: 50
    },
    {
      Header: 'Total',
      accessor: 'amountIncTax',
      Cell: props => <p className="">{props.row._original.currency} {props.value}</p>,
      style: { 'whiteSpace': 'unset' }
    },
    {
      Header: 'Name',
      accessor: 'guestName',
      Cell: props => <p className="">{props.value}</p>,
      style: { 'whiteSpace': 'unset' }
    },
    {
      Header: 'Email',
      accessor: 'guestEmail',
      Cell: props => <p className="">{props.value}</p>,
      style: { 'whiteSpace': 'unset' }
    },
    {
      Header: 'Mobile Number',
      accessor: 'guestMobile',
      Cell: props => <p className="">{props.value}</p>,
      style: { 'whiteSpace': 'unset' }
    },
    {
      Header: 'Booking Status',
      accessor: 'bookingStatus',
      Cell: props => <p className="">{props.value}</p>,
    },
    {
      Header: 'Payment',
      accessor: 'paymentStatus',
      Cell: props => <p className="">{props.value}</p>,
    },
    {
      Header: '',
      accessor: 'bookingId',
      Cell: props => <DetailButton id={props.value} BindData={BindData} />,
    }
  ];

  const handleChangeDate = date => {
    setStartDate(moment(date))
  };
  const handleChangeEndDate = date => {
    setEndDate(moment(date))
  };

  const handleSubmitClick = () => {
    BindData();
  };

  useEffect(() => {
    BindData();
  }, [propertyId]);

  function BindData() {
    let fromDate = startDate ? moment(startDate).format('YYYY-MM-DD') + ' 00:00:00' : '';
    let toDate = endDate ? endDate.format('YYYY-MM-DD') + ' 23:59:59' : '';
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Bookings_list}?propertyId=${propertyId}&dateFrom=${fromDate}&dateTo=${toDate}`,
    })
      .then(res => {
        console.log('res.data', res.data);
        setBookingsList(res.data)
        setIsLoading(false)

      })
      .catch(err => console.log('err', err));
  }

  return (
    <Fragment>
      <Row>
        {!isFiltering && (
          <Colxx
            xxs="12"
            md="1"
            className="mb-2"
            onClick={() => setIsFiltering(true)}
          >
            <TuneIcon />
          </Colxx>
        )}
        {isFiltering && (
          <Fragment>
            <Colxx xxs="12" md="2" className="mb-2">
              <DatePicker
                selected={startDate ? new Date(startDate) : null} // ensure Date object
                onChange={handleChangeDate}
                placeholderText="Start Date"
                dateFormat="dd/MM/yyyy"   // ✅ correct format
              />
            </Colxx>
            <Colxx xxs="12" md="2" className="mb-2">
              <DatePicker
                selected={endDate ? new Date(endDate) : null} // ✅ always Date object
                onChange={handleChangeEndDate}
                placeholderText="End Date"
                dateFormat="dd/MM/yyyy"   // ✅ correct format
              />
            </Colxx>
            <Colxx xxs="12" md="1" className="mb-2">
              <Button
                color="primary"
                className="mb-2"
                onClick={() => handleSubmitClick()}
              >
                <IntlMessages id="forms.submit" />
              </Button>
            </Colxx>
          </Fragment>
        )}

      </Row>
      <Row>
        <Colxx xxs="12" className="mb-2">
          <Fragment>
            <CardTitle>Bookings</CardTitle>
            <Colxx xxs="12" className="mb-2 text-right">
              <strong><hr /></strong>
            </Colxx>
            <Card className="mb-2">
              <CardBody>
                {!isLoading && bookingsList ? (
                  <ReactTable
                    data={bookingsList}
                    columns={dataTableColumns}
                    defaultPageSize={10}
                    filterable={false}
                    showPageJump={true}
                    PaginationComponent={DataTablePagination}
                    showPageSizeOptions={true}
                    className="-striped -highlight -bordered"

                  />
                ) : (
                  <div className="loading" />
                )}
              </CardBody>
            </Card>
          </Fragment>
        </Colxx>
      </Row>
      {/* <Colxx xxs="12">
        <Card
          className="d-flex flex-row mb-3"
          style={{ cursor: 'pointer' }}
          onClick={() => setVisible(!visible)}
        >
          <div className="pl-2 d-flex flex-grow-1 min-width-zero">
            <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
              <p className="mb-1  text-small w-20 w-sm-100">
                {booking.bookingNumber}
              </p>
              <p className="mb-1  text-small w-15 w-sm-100">
                {moment(booking.checkInDate).format('DD/MM/YYYY')}
              </p>
              <p className="mb-1  text-small w-15 w-sm-100">
                {moment(booking.checkOutDate).format('DD/MM/YYYY')}
              </p>
              <div className="w-10 w-sm-100">{booking.adults}</div>
              <div className="w-10 w-sm-100">{booking.childrens}</div>
              <div className="w-10 w-sm-100">{booking.roomsUnits}</div>
              <div className="w-15 w-sm-100">
                {booking.currency} {booking.amountIncTax}
              </div>
              <div className="w-15 w-sm-100">
                {booking.currency} {booking.amountExTax}
              </div>
              <div className="w-15 w-sm-100">{booking.guestName}</div>
              <div className="w-30 w-sm-100">{booking.guestEmail}</div>
              <div className="w-15 w-sm-100">{booking.bookingStatus}</div>
              <div className="w-15 w-sm-100">{booking.paymentStatus}</div>
              <div className="w-15 w-sm-100">
                <Button
                  color="primary"
                  size="xs"
                  onClick={() => setVisible(!visible)}
                >
                  Detail
              </Button>
                {visible && (
                  <BookingDetail
                    bookingId={booking.bookingId}
                    visible={visible}
                    toggle={() => setVisible(!visible)}
                  />)}
              </div>
            </div>
          </div>
        </Card>
      </Colxx> */}
    </Fragment>
  );
};


const mapStateToProps = ({ settings }) => {
  const { propertyId } = settings;
  return {
    propertyId,
  };
};

export default injectIntl(connect(mapStateToProps, {})(BookingsList));
